<ion-row class="row ion-text-center">
    <ion-col>
        <ion-button class="bar-button" color="gray" (click)="downloadMatch()" expand="block" fill="clear">
            <div *ngIf="!isLoading">
                <ion-icon name="cloud-download-outline"></ion-icon>
                <span>{{ 'Download' | translate }}</span>
            </div>
            <ion-spinner name="crescent" *ngIf="isLoading"></ion-spinner>
        </ion-button>
    </ion-col>
</ion-row>